<template>
  <div
    class="dialog_views"
    v-if="isShowMessageBox"
    @touchmove.prevent
  >
    <div
      class="UImask"
      @click="cancel"
    >
      <transition name="confirm-fade">
        <div
          class="UIdialog"
          v-show="isShowMessageBox"
        >
          <div class="UIdialog_bd">
            <slot>{{content}}</slot>
          </div>
          <div class="operators">
            <span
              v-if="isShowCancelBtn"
              class="UIdialog_btn"
              @click="cancel"
            >{{cancelVal}}</span>
            <span
              v-if="isShowConfimrBtn"
              class="UIdialog_btn"
              @click="confirm"
            >{{confirmVal}}</span>
          </div>

        </div>
      </transition>
    </div>
  </div>

</template>

<script>
export default {
  components: {},
  data() {
    return {
      isShowMessageBox: false,
      resolve: '',
      reject: '',
      promise: '' // 保存promise对象
    }
  },
  props: {
    isShowConfimrBtn: {
      type: Boolean,
      default: true
    },
    content: {
      type: String,
      default: '这是弹框内容'
    },
    isShowCancelBtn: {
      //是否展示取消按钮
      type: Boolean,
      default: true
    },
    title: {
      //标题
      type: String,
      default: '提示'
    },
    confirmVal: {
      type: String, //确认文字
      default: '确定'
    },
    cancelVal: {
      //取消文字
      type: String,
      default: '取消'
    },
    maskHide: {
      type: Boolean, //是否可以点击蒙层关闭
      default: true
    }
  },

  methods: {
    // 确定,将promise断定为resolve状态
    confirm() {
      this.isShowMessageBox = false
      this.resolve('confirm')
      this.remove()
    },
    // 取消,将promise断定为reject状态
    cancel() {
      this.isShowMessageBox = false
      this.reject('cancel')
      this.remove()
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox() {
      this.isShowMessageBox = true
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
      // 返回promise对象
      return this.promise
    },
    remove() {
      document.body.style.overflow = 'auto'
    }
  },
  created() {
    document.body.style.overflow = 'hidden'
  }
}
</script>
<style lang='less' scoped>
.UImask {
  position: fixed;
  z-index: 999;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
}
.UIdialog {
  position: absolute;
  left: calc(50% - 250px);
  top: 319PX;
  z-index: 1000;
  width: 500px;
  background: rgba(11,25,66,0.9);
  border: 1px solid #00D2FA;
  transition: opacity 0.3s, transform 0.4s;
  padding: 36px 52px;
  box-sizing: border-box;
}
.UIdialog_bd {
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
  font-size: .16rem;
}

.operators {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    margin-top: 30px;
    .UIdialog_btn {
      margin-right: 36px;
      padding: 0 32px;
      box-sizing: border-box;
      border-radius: 15px;
      border: 1px solid #FFFFFF;
      height: 30px;
      line-height: 28px;
      font-weight: 400;
      color: #FFFFFF;
      font-size: .16rem;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
        height: 30px;
        line-height: 30px;
        background: #FF564D;
        border-radius: 15px;
        color: #FFFFFF;
        border: none;
      }
    }
}

/* 进入和出去的动画 */
.confirm-fade-enter-active {
  animation: bounce-in 0.5s;
}
.confirm-fade-leave-active {
  animation: bounce-in 0.5s reverse;
}
.confirm-fade-enter,
.confirm-fade-leave-to {
  opacity: 0;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}


</style>
